import './ImportProduct.css';
import SlButton from '@shoelace-style/shoelace/dist/react/button/index.js';
import SlIcon from '@shoelace-style/shoelace/dist/react/icon/index.js';
import SlAlert from '@shoelace-style/shoelace/dist/react/alert/index.js';
import { useTranslation } from 'react-i18next';
import { useImportProduct } from './useImportProduct';
import { Link } from '@anticatrade/shared';
import { Heading } from '../../base/Heading/Heading';

const ImportProduct = () => {
	const { t } = useTranslation();
	const { url, setUrl, platform, setPlatform, isImporting, error, onImport } =
		useImportProduct();

	const onKeyDown = (e: React.KeyboardEvent) => {
		if (e.key === 'Enter' && url.trim() && !isImporting) {
			onImport();
		}
	};

	return (
		<div className='import-product'>
			<Heading
				left={
					<div className='import-product__heading'>
						<Link path='/products'>
							<SlButton
								className='import-product__exit-button'
								variant='text'
								size='medium'
							>
								<SlIcon name='arrow-left' slot='prefix' />
							</SlButton>
						</Link>
						<h1 className='import-product__title'>{t('Import item')}</h1>
					</div>
				}
			/>
			<div className='import-product__content wrapped'>
				<p className='import-product__description'>
					{t('Import item description')}
				</p>
				<div className='import-product__form'>
					<div className='import-product__input-group'>
						<select
							className='import-product__platform'
							value={platform}
							onChange={(e) => setPlatform(e.target.value)}
							disabled={isImporting}
						>
							<option value='proantic'>Proantic</option>
						</select>
						<input
							className='import-product__url'
							type='url'
							placeholder={t('Paste the URL of the item...')}
							value={url}
							onChange={(e) => setUrl(e.target.value)}
							onKeyDown={onKeyDown}
							disabled={isImporting}
							autoFocus
						/>
					</div>
					<SlButton
						className='import-product__button'
						variant='primary'
						onClick={onImport}
						loading={isImporting}
						disabled={!url.trim() || isImporting}
					>
						{t('Import')}
					</SlButton>
				</div>
				{error && (
					<SlAlert className='import-product__error' variant='danger' open>
						<SlIcon slot='icon' name='exclamation-circle-fill' />
						{error}
					</SlAlert>
				)}
			</div>
		</div>
	);
};

export { ImportProduct };
